import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';

import { ContentStatus } from '../constants/ContentStatus.ts';
import { preloadContentDataClassification } from './preloadContentDataClassification.ts';

export async function preloadClassificationContextForEditContent(contentId: string): Promise<any> {
	const queries: Promise<any>[] = [];

	queries.push(preloadContentDataClassification(contentId, ContentStatus.DRAFT));

	return waitForAllReturnWhenError(queries);
}
